/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import { t } from "i18next";

import { CONSTANTS } from "@constants/index";
import { CollapsibleTextEnum } from "@enums/shared.enum";
import { CollapsibleTextProps } from "@models/shared/shared.model";

import ImageSlickSlider from "../ImageSlickSlider/ImageSlickSlider";
const CollapsibleText: React.FC<CollapsibleTextProps> = ({
  className,
  content,
  heading = "",
  isSlider = false,
  isSubheading = false,
  sliderImage = [],
}) => {
  const [iseExpanded, setIseExpanded] = useState<boolean>(false);
  const customClassName = className ? className : "fg-tab-welcome-block";
  const textGridClassName =
    isSlider && sliderImage.length > 0
      ? "col-sm-12 col-lg-8"
      : "col-sm-12 col-lg-12";
  const sliderGridClassName =
    isSlider && sliderImage.length ? "col-sm-12 col-lg-4" : "";
  const truncateContent = content?.substring(
    CollapsibleTextEnum.Zero,
    CollapsibleTextEnum.TrimCharacterCount
  );
  const readMoreContent =
    content.length > CollapsibleTextEnum.TrimCharacterCount
      ? truncateContent?.concat(CONSTANTS.OTHERS.MORE)
      : truncateContent;

  if (!content && !heading && !sliderImage.length) return;

  return (
    <div className={customClassName} data-testid="collapsibleText-test">
      {heading && (isSubheading ? <h5>{heading}</h5> : <h4>{heading}</h4>)}
      <div className="row">
        <div className={textGridClassName}>
          {content && (
            <>
              <p
                className="fg-readmore-block"
                dangerouslySetInnerHTML={{
                  __html: iseExpanded ? content : readMoreContent,
                }}
              ></p>
              <span
                className="fg-read-more-btn"
                onClick={() => {
                  setIseExpanded(!iseExpanded);
                }}
                data-testid="readMore-test"
              >
                {content.length > CollapsibleTextEnum.TrimCharacterCount
                  ? iseExpanded
                    ? t("ReadLess")
                    : t("ReadMore")
                  : ""}
              </span>
            </>
          )}
        </div>
        <div className={sliderGridClassName}>
          {isSlider && sliderImage.length > 0 && (
            <div className="fg-slider-block">
              <ImageSlickSlider image={sliderImage} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CollapsibleText;
